// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { StyledButton } from "@insite/mobius/Clickable";
import { IconWrapper } from "@insite/mobius/Icon";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import { footerContainerStyles } from "@west/Overrides/Widgets/Footer/FooterContainer";
import { DivWrapper } from "@west/XDL/constants";
import { fontConfig } from "@west/XDL/PreStyle/typography";
import { color, layoutContainer, xScreen } from "@west/XDL/Utilities";
import { css } from "styled-components";

footerContainerStyles.container = {
    css: css`
        display: flex;
        flex-direction: column;
    `,
};

footerContainerStyles.topSectionContainer = {
    css: css`
        display: flex;
        margin-bottom: 40px;
        width: 100%;

        ${layoutContainer}

        ${xScreen("lte", "md")} {
            flex-direction: column;
            gap: 40px;
            width: 100%;
            margin-bottom: 28px;
        }
    `,
};

footerContainerStyles.linkListSectionContainer = {
    css: css`
        display: flex;
        gap: 22px;
        justify-content: space-between;
        width: 100%;

        ${xScreen("lte", "md")} {
            flex-wrap: wrap;
        }
        ${xScreen("lte", 697)} {
            gap: 24px;
        }
    `,
};

footerContainerStyles.linkListWrapper = {
    css: css`
        max-width: 204px;
        flex-basis: calc(33.33% - 22px);
        ${xScreen("lte", 697)} {
            flex-basis: calc(50% - 24px);
        }
    `,
};

footerContainerStyles.contactUsAndInfoWrapper = {
    css: css`
        max-width: 204px;
        flex-basis: calc(33.33% - 22px);
        .list-link {
            margin-bottom: 4px;
            & > ${TypographyStyle} {
                line-height: 14px;
                color: ${color("common.white")};
                font-weight: ${fontConfig.weight.bold};
            }
        }
        .info-wrapper {
            div {
                display: flex;
            }
            & > ${DivWrapper} {
                flex-direction: column;
                gap: 4px;
            }
            .info-text {
                color: ${color("common.white")};
                font-size: 10px;
                line-height: 16px;
            }
            border-top: 1px solid ${color("common.ui14")};
            margin-top: 12px;
            padding-top: 16px;
            display: flex;
            flex-direction: column;
            .list-link {
                margin-bottom: 0;
            }
            .links-wrapper {
                margin-bottom: 0;
            }
        }
        ${xScreen("lte", "md")} {
            max-width: 20%;
            margin-top: 18px;
        }
        ${xScreen("lte", 697)} {
            max-width: 50%;
            margin-top: 0;
            flex-basis: calc(50% - 24px);
        }
    `,
};

footerContainerStyles.bottomSectionContainer = {
    css: css`
        background-color: ${color("common.ui14")};
        padding: 6px 0;
        & > div {
            display: flex;
            align-items: center;
            ${layoutContainer}

            ${xScreen("lt", "sm")} {
                flex-direction: column;
                align-items: flex-start;
                gap: 8px;
            }

            & > ${DivWrapper} {
                div.wrapper > ${TypographyStyle} {
                    font-size: 12px;
                    font-weight: ${fontConfig.weight.regular};
                    letter-spacing: 0;
                    line-height: 20px;
                }
            }
        }

        ${({ isCheckoutPages }: any) =>
            isCheckoutPages &&
            css`
                margin-top: -24px;
                padding: 12px 0;
                background-color: ${color("common.black")};
            `}
    `,
};

footerContainerStyles.subscribeAndSocialLinkWrapper = {
    css: css`
        min-width: 430px;
        display: flex;
        flex-direction: column;
        gap: 24px;
        flex: 1 1 0;
        padding-right: 32px;
        max-width: 430px;

        ${xScreen("lte", "md")} {
            margin-top: 18px;
            padding-right: 85px;
        }
        ${xScreen("lte", 697)} {
            margin-left: 0;
            margin-top: 0;
            padding-right: 0;
            min-width: unset;
            width: 100%;
        }
    `,
};

footerContainerStyles.copyRightWrapper = {
    css: css`
        font-size: 12px;
        letter-spacing: 0;
        line-height: 20px;
        white-space: nowrap;
        font-weight: normal;
        color: ${color("common.white")};
    `,
};
